import { CommonModule } from "@angular/common";
import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LobbySearchComponent } from "@components/casino/lobby-search/lobby-search";
import { IonicModule } from "@ionic/angular";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { TranslateModule } from "@ngx-translate/core";
import { BaseService } from "@providers/BaseService";
import { Subject, Subscription, debounceTime, fromEvent, takeUntil } from "rxjs";

@Component({
  selector: "lb-search-bar",
  templateUrl: "./lobby-search-bar.html",
  standalone: true,
  styleUrls: ["./lobby-search-bar.scss"],
  imports: [CommonModule, LobbySearchComponent, FormsModule, IonicModule, TranslateModule],
})
export class LobbySearchBarComponent extends BaseService implements OnDestroy {
  @Output() search: EventEmitter<string> = new EventEmitter();
  @Output() filtersClick: EventEmitter<void> = new EventEmitter();
  @Output() calendarClick: EventEmitter<void> = new EventEmitter();
  @ViewChild("searchInput") searchInput: ElementRef;

  private subscription$: Subscription = new Subscription();
  declare globalVars: GlobalVarsModel;
  destroy$: Subject<void> = new Subject<void>();
  term = "";

  constructor() {
    super();
    this.newBaseService.getVars.pipe(takeUntil(this.destroy$)).subscribe((data: GlobalVarsModel) => {
      this.globalVars = data;
    });
  }

  ngAfterViewInit(): void {
    const keyup$ = fromEvent(this.searchInput.nativeElement, "keyup", () => {})
      .pipe(debounceTime(350))
      .subscribe(() => {
        this.search.emit(this.term);
      });

    this.subscription$.add(keyup$);
  }

  filtersClicked() {
    this.filtersClick.emit();
  }

  calendarClicked() {
    this.calendarClick.emit();
  }

  clearTerm() {
    this.term = "";
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
